export var showGameStateForEvent = function (ids, sportId) {
    return ids.find(function (id) { return id === sportId; }) ? true : false;
};
//# sourceMappingURL=showGameStateForEvent.js.map